import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {constance} from "../../../common/constance/constance";
import {MenuItem, MenuList, Paper} from "@mui/material";
import {Club} from "../../../interface/club.interface";
import React, {useEffect, useMemo, useState} from "react";
import axios from "axios";
import {MenuInterface} from "../../../interface/menu.interface";
import {common} from "../../../common/common";

export default function SelectClubComponent(props: { state: any, setState: any, workplace: string }) {
    const [selectOptionOpen, setSelectOptionOpen] = useState(false);
    const [clubList, setClubList] = useState<Club[]>([]);
    let {id, workplace, no, page} = common.getQuery();
    let menu: MenuInterface = useMemo(() => common.getMenuObject(id), [id]);

    useEffect(() => {
        axios.get(constance.api.getClubList).then(value => {
            console.log('constance.api.getClubList');
            setClubList(value.data.clubList)
        })
    }, []);

    function handleSelectOptionOpen(isOpen: boolean) {
        setSelectOptionOpen(isOpen)
    }

    function selectClub(e: React.MouseEvent<HTMLLIElement>, club: Club) {
        setSelectOptionOpen(false);
        props.setState(club);
    }

    return (
        <Box sx={{
            width: 1,
            display: 'flex',
            justifyContent: 'flex-start', alignItems: 'center',
            mb: 1,
            backgroundColor: 'var(--scc-surface)'
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 1,
                p: 2,
                width: 100,
                backgroundColor: '#696969',
            }}>
                <Typography sx={{color: 'white'}}> 동호회 선택 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                {/* 부서 선택 textfield */}
                <TextField placeholder="사업장 선택 후 선택해주세요."
                           value={props.state._id == '' ? '' : `[${constance.workplaceNameMap[props.state.workplace]}] ${props.state.name}`}
                           onClick={() => handleSelectOptionOpen(props.state.workplace == '-1' ? false : true)}
                           disabled={props.state.workplace == '-1'}
                           variant="outlined"
                           sx={{width: 1, backgroundColor: 'var(--scc-surface)'}}
                />
                <Paper sx={{
                    width: 320, maxWidth: '100%',
                    position: 'absolute',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    zIndex: 10,
                    display: selectOptionOpen ? 'flex' : 'none',
                }}>
                    <MenuList sx={{width: 1,}}>
                        {
                            clubList.map((club: Club, index: number) => {
                                if (club.workplace != props.workplace) return;
                                return (
                                    <MenuItem value={club._id}
                                              key={index}
                                              sx={{width: 1}}
                                              onClick={(e) => selectClub(e, club)}
                                    >
                                        <Typography>
                                            {`[${constance.workplaceNameMap[club.workplace]}] ${club.name}`}
                                        </Typography>
                                    </MenuItem>
                                );
                            })
                        }

                    </MenuList>
                </Paper>
            </Box>
        </Box>
    )
}